import { PlaceholderScreen } from "@/shell/PlaceholderScreen";

export default function Cart() {
  return <PlaceholderScreen title="Cart" testID="placeholder-cart" />;
}
